import store from "@/store/index";
import router from "@/router/index";
import { Moment } from "@/typescript/lib/common/moment";
const format = "YYYY-MM-DD HH:mm:ss";

export function getBearerToken(): string | void {
  const expires = new Moment(
    format,
    store.state.authInfo[".expires"]
  ).getFormatDate();
  const now = new Moment(format).getFormatDate();

  // トークンが有効期限切れでなければ、トークンを返却する
  if (!Moment.isBefore(expires, now)) {
    return `Bearer ${store.state.authInfo.access_token}`;
  }

  alert("ログイン有効切れです。再度ログインして下さい。");
  router.push("/login");
  store.commit("setAuthInfo", {
    authInfo: {}
  });
  store.commit("setUserInfo", {
    userInfo: {}
  });
}
